// extracted by mini-css-extract-plugin
export default {"root":"spinner___root___bbb5c8a4","text":"spinner___text___f1eb0b0c"};